export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 768;
export const menuHiddenBreakpoint = 576;
export const defaultAppLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - EN', direction: 'ltr' },
  { id: 'bg', name: 'Български - BG', direction: 'ltr' },
  { id: 'zh-CN', name: '中文 - CN', direction: 'ltr' },
  { id: 'cs', name: 'Čeština - CS', direction: 'ltr' },
  { id: 'de', name: 'Deutsch - DE', direction: 'ltr' },
  { id: 'el', name: 'Νέα Ελληνικά - EL', direction: 'ltr' },
  { id: 'es', name: 'Español - ES', direction: 'ltr' },
  { id: 'fi', name: 'Suomi - FI', direction: 'ltr' },
  { id: 'fr', name: 'Français - FR', direction: 'ltr' },
  { id: 'hr', name: 'Hrvatski - HR', direction: 'ltr' },
  { id: 'hu', name: 'Magyar - HU', direction: 'ltr' },
  { id: 'it', name: 'Italiano - IT', direction: 'ltr' },
  { id: 'ka', name: 'ქართული - KA', direction: 'ltr' },
  { id: 'ko', name: '한국어 - KO', direction: 'ltr' },
  { id: 'nl', name: 'Nederlands - NL', direction: 'ltr' },
  { id: 'pl', name: 'Polski - PL', direction: 'ltr' },
  { id: 'ro', name: 'Română - RO', direction: 'ltr' },
  { id: 'ru', name: 'Ру́сски - RU', direction: 'ltr' },
  { id: 'sl', name: 'Slovenščina - SL', direction: 'ltr' },
  { id: 'sr', name: 'Srpski - SR', direction: 'ltr' },
  { id: 'tr', name: 'Türk - TR', direction: 'ltr' },
  { id: 'uk', name: 'Українська - UK', direction: 'ltr' },
  { id: 'vi', name: 'Tiếng Việt - VI', direction: 'ltr' },
];

export const translationLocaleOptions = localeOptions;

export const defaultDirection = 'ltr';

export enum joinCommunityStates {
  REQUESTED_JOIN = 'REQUESTED_JOIN',
  BANNED = 'BANNED',
  INVITED = 'INVITED',
  JOINED = 'JOINED',
}

// Hardcoded to enable wechat pay only for Greensteps Shanghai when creating an activity
export const GS_SH_SLUG = 'green-steps';
